import React, { useState } from 'react';
import { Button, Chip, Icon, Modal, Text, TextField } from '@nike/eds';
import { useI18nContext } from '../../../context/language/use-i18n-context';
import { translations } from './i18n';
import styles from './resend-email.module.css';
import { translations as ts } from './i18n';

interface ResendEmailProps {
  visitorId: number;
  isActiveSwoosh: boolean;
  email?: string;
  showModal?: boolean;
  onResend: (visitorId: number) => void;
  onDismiss: () => void;
}

export const FamilyResendEmail: React.FC<ResendEmailProps> = ({
  visitorId,
  isActiveSwoosh = false,
  email = '',
  showModal = false,
  onDismiss,
  onResend,
}) => {
  const { i18nString } = useI18nContext();

  const handleResend = async () => {
    onResend(visitorId);
  };

  const header = (
    <>
      <Text
        as={'h1'}
        data-testid="resend-email-header"
        className={`eds-flex eds-flex--justify-content-center modal_header`}
      >
        {i18nString(ts.RESEND_EMAIL_FAMILY_MODAL)}
      </Text>
    </>
  );

  return (
    <>
      <Modal
        isOpen={showModal}
        headerSlot={header}
        onDismiss={onDismiss}
        hideFade
        id="familyresend-email"
        data-testid="resend-email-modal"
      >
        <div className={styles.resendEmailContainer}>
          <Chip
            className={isActiveSwoosh ? styles.swooshBtn_active : styles.swooshBtn}
            as="span"
            beforeSlot={<Icon name="NikeSwoosh" />}
          >
            SWOOSH
          </Chip>
          <TextField
            id="family-email"
            data-testid="family-email-input"
            className={styles.emailField}
            label="swoosh email"
            aria-label="swoosh email"
            hideLabel={true}
            type="email"
            name="email"
            value={email}
            disabled={true}
          />
          <Button
            size="medium"
            variant="primary"
            disabled={!isActiveSwoosh}
            className={styles.resendButton}
            onClick={handleResend}
            data-testid="family-resend-button"
          >
            {i18nString(translations.RESEND_EMAIL_FAMILY_MODAL_BUTTON)}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default FamilyResendEmail;
